// @flow
import { colors } from 'bench-style-constants';
import { rgba } from 'color-helpers';
import { css } from 'styled-components';

export const invalidStyling = `
  border-color: ${colors.copper};
  color: ${colors.copper};
  
  &:focus {
    background-image: none;
    border-color: ${colors.copper};
    box-shadow: 0 0 4px 1px ${colors.copper};
    color: #3a3b40;
    // Prevents excess white space in input when background image is hidden
    padding: 0 11px;
  }
`;

export const inputStyle = css`
  background-color: ${colors.white};
  border: 1px solid ${colors.stone};
  border-radius: 2px;
  // "width: 100%" combined with horizontal padding or borders requires "box-sizing: border-box" to
  // prevent horizontal overflow
  box-sizing: border-box;
  color: #3a3b40;
  font-size: 12px;
  padding: 0 11px;
  width: 100%;

  ::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }

  &:hover {
    border-color: ${colors.dust};
  }

  &:focus {
    border-color: ${colors.dust};
    box-shadow: 0 0 4px 1px ${rgba(colors.creek, 0.65)};
    outline: none;
  }

  ${({ errorText }) =>
    errorText &&
    css`
      ${invalidStyling};
    `};

  &:disabled {
    background: ${colors.sand};
    border-color: ${colors.sand};
    color: ${colors.dust};
  }

  &::placeholder {
    color: ${colors.dust};
  }
`;
